import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import useMe from '../../resources/me';
import usePrequal from '../../resources/prequal/usePrequal';
import Navigate from '../Navigate';
import DeclinedReminder from '../DeclinedReminder';
import Authenticated from '../Authenticated';
import Unauthenticated from '../Unauthenticated';
import Error from '../Error';
import useSetRUMUser from '../../hooks/useSetRUMUser';

// Determines where a user in any state should end up when the app boots.
const Checkpoint = () => {
  const { data: me } = useMe();
  const { data: prequal } = usePrequal();
  useSetRUMUser({ me, prequal });

  const blockDeclineReminder = sessionStorage.getItem('blockDeclineReminder');

  if (me && me.role !== 'CUSTOMER') {
    // Non-consumers are navigated to auth
    // where they will be sorted out based on their role.
    return <Navigate to={`/${process.env.PREFIX}/auth`} />;
  }

  const params = new URLSearchParams(window.location.search);
  const hasReapplyFlag = params.has('reapply') || params.has('prefillId');
  const shouldRedirectToPortal = me?.contracted && !hasReapplyFlag;
  if (shouldRedirectToPortal) {
    // In general, previously underwritten consumers should focus on
    // their existing account in their portal.
    //
    // For cases of new or pending reapplies,
    // the portal sets a ?reapply query parameter when it sends the user here.
    //
    // If a consumer does not carry this parameter,
    // navigate them to the consumer portal.
    return <Navigate to={`/${process.env.PREFIX}/customers/${me.userId}`} />;
  }

  if (prequal?.decision?.decision === 'DECLINED' && !blockDeclineReminder) {
    // Declined prequals are returned by the status endpoint for 30 days.
    // Consumers who have a decline during this 30 day window
    // should see a message reminding them of this outstanding decline.
    //
    // This message is blocked by a flag in session storage until the consumer
    // has seen their original decline message.
    return <DeclinedReminder />;
  }

  if (me) {
    // A new reapply or a pending app
    return <Authenticated />;
  }

  // A brand-new consumer (no session, no prequal, no nothing) who should start from the top
  return <Unauthenticated />;
};

export default withErrorBoundary(Checkpoint, { fallbackRender: Error });
